export const MODALS = {
  STORE_SHOP: 'STORE_SHOP',
  CHOOSE_STRETCH: 'CHOOSE_STRETCH',
};
